const formatPidSection = (str: string, char: string): string =>
  str.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, char)

export const generatePendoId = (elementType: string, id: string): string =>
  `${formatPidSection(elementType, '-')}--${formatPidSection(id, '_')}`.toLowerCase()
